import { createWizard } from "../wizards";

export type OfferClaimFlowPages = "OfferPage" | "OfferClaimed";

export const offerClaimFlowWizard = createWizard<OfferClaimFlowPages>("OfferClaimFlowWizard", [
    "OfferPage",
    "OfferClaimed",
]);
